import type { Variant } from '@storefront/lib-global/codegen/types';

export const hasMatchingWidthVariant = (productSize: string, selectedWidth: string, variants: Variant[]): boolean =>
  selectedWidth ? variants.some((variant) => variant.size === productSize && variant.fitLabel === selectedWidth) : true;
